/**
 * Below Tailwind's lg the tool stacks: the form and the blue panel swap in place and only one is on
 * stage at a time. Written in rem like the utility classes, so a visitor with a larger root font
 * size crosses over at the same point the layout does.
 */
export function isPhoneLayout(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }

  return !window.matchMedia('(min-width: 64rem)').matches
}
